import { WalletType } from '@types';

export class BrowserExtensionNotInstalledError extends Error {
  constructor(public walletType: WalletType) {
    super(`Browser Extension ${walletType} not installed`);
    Object.setPrototypeOf(this, BrowserExtensionNotInstalledError.prototype);
  }
}

export class InvalidInputError extends Error {
  constructor(public payload: string) {
    super(`Invalid input: ${payload}`);
    Object.setPrototypeOf(this, InvalidInputError.prototype);
  }
}

export class UnsupportedError extends Error {
  constructor(public value: string) {
    super(`Unsupported value: ${value}`);
    Object.setPrototypeOf(this, UnsupportedError.prototype);
  }
}

export class UserRejectedWalletConnectionRequestError extends Error {
  constructor() {
    super('User Rejected Request');
    Object.setPrototypeOf(
      this,
      UserRejectedWalletConnectionRequestError.prototype
    );
  }
}
